(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["discount-offers"] && !Shopify.designMode) return;
  try {
    class OfferSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.offer-slider__track');
    this.viewport = this.querySelector('.offer-slider__viewport');
    this.dotsRow = this.querySelector('[data-dots-row]');
    this.dotsWrap = this.querySelector('.offer-slider__dots');
    if (!this.track) return;

    this.slides = Array.from(this.track.children);
    this.index = 0;
    this.speed = parseInt(this.dataset.speed || '400', 10);
    this.loop = this.dataset.loop === 'true';
    this.showDots = this.dataset.showDots === 'true';
    this.autoplay = this.dataset.autoplay === 'true';
    this.interval = parseInt(this.dataset.interval || '5000', 10);

    this.buildDots();
    this.apply(false);
    this.bind();
    this.startAuto();
  }

  disconnectedCallback() { this.stopAuto(); }

  buildDots() {
    if (!this.dotsWrap) return;
    this.dotsWrap.innerHTML = '';
    const enabled = this.showDots && this.slides.length > 1;
    this.setAttribute('data-has-dots', enabled ? 'true' : 'false');
    if (this.dotsRow) this.dotsRow.hidden = !enabled;
    if (!enabled) return;

    this.slides.forEach((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'offer-slider__dot';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Offer ' + (i + 1));
      b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      b.addEventListener('click', () => { this.goTo(i); this.restartAuto(); });
      this.dotsWrap.appendChild(b);
    });
    this.dots = Array.from(this.dotsWrap.children);
  }

  apply(animate, offset) {
    const px = offset ? ` + ${offset}px` : '';
    this.track.style.transition = animate ? `transform ${this.speed}ms cubic-bezier(.4,0,.2,1)` : 'none';
    this.track.style.transform = `translate3d(calc(${-this.index * 100}%${px}), 0, 0)`;
  }

  goTo(i, animate = true) {
    const max = this.slides.length - 1;
    if (i < 0) i = this.loop ? max : 0;
    if (i > max) i = this.loop ? 0 : max;
    this.index = i;
    this.apply(animate);
    if (this.dots) this.dots.forEach((d, n) => d.setAttribute('aria-selected', n === i ? 'true' : 'false'));
  }

  next() { this.goTo(this.index + 1); }

  startAuto() {
    if (!this.autoplay || this.slides.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.timer = setInterval(() => { if (!document.hidden) this.next(); }, this.interval);
  }
  stopAuto() { if (this.timer) clearInterval(this.timer); this.timer = null; }
  restartAuto() { this.stopAuto(); this.startAuto(); }

  bind() {
    this.addEventListener('mouseenter', () => this.stopAuto());
    this.addEventListener('mouseleave', () => this.startAuto());
    this.addEventListener('focusin', () => this.stopAuto());

    this.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-copy-code]');
      if (btn) this.copyCode(btn);
    });

    let startX = 0, dx = 0, dragging = false;
    const threshold = 45;

    this.viewport.addEventListener('pointerdown', (e) => {
      if (e.target.closest('[data-copy-code]') || this.slides.length < 2) return;
      dragging = true; startX = e.clientX; dx = 0;
      this.viewport.classList.add('is-dragging');
      this.viewport.setPointerCapture(e.pointerId);
      this.stopAuto();
    });
    this.viewport.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      dx = e.clientX - startX;
      this.apply(false, dx);
    });
    const end = () => {
      if (!dragging) return;
      dragging = false;
      this.viewport.classList.remove('is-dragging');
      if (Math.abs(dx) > threshold) { this.goTo(this.index + (dx < 0 ? 1 : -1)); }
      else { this.apply(true); }
      this.startAuto();
    };
    this.viewport.addEventListener('pointerup', end);
    this.viewport.addEventListener('pointercancel', end);
    this.viewport.addEventListener('pointerleave', end);

    this.addEventListener('shopify:block:select', (e) => {
      const i = this.slides.indexOf(e.target.closest('.offer-slider__track > *'));
      if (i > -1) this.goTo(i);
      this.stopAuto();
    });
    this.addEventListener('shopify:block:deselect', () => this.startAuto());
  }

  async copyCode(btn) {
    const code = btn.getAttribute('data-copy-code');
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(code);
      } else {
        const ta = document.createElement('textarea');
        ta.value = code;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      btn.classList.add('is-copied');
      clearTimeout(btn._t);
      btn._t = setTimeout(() => btn.classList.remove('is-copied'), 1800);
    } catch (err) { console.error(err); }
  }
}

if (!customElements.get('offer-slider')) customElements.define('offer-slider', OfferSlider);
  } catch(e) { console.error(e); }
})();

})();
